import { type MenuItem, ProfileMenuGroup } from 'shared/types'

export type WebhookSettingsProps = {
  isWebhookSettingsEnabled?: boolean
  hasEcommercePoi?: boolean
}

export function webhooksProfileMenu({
  isWebhookSettingsEnabled = false,
  hasEcommercePoi = false
}: WebhookSettingsProps = {}): MenuItem[] {
  return [
    {
      order: 10,
      label: 'Webhooks',
      icon: 'code',
      show: isWebhookSettingsEnabled && hasEcommercePoi,
      path: '/vendas-online/webhooks',
      active: (route: string) => ['/vendas-online/webhooks', '/digital-settings/webhooks'].includes(route),
      group: ProfileMenuGroup.ONLINE_SALES
    }
  ]
}
